import axios from 'axios';

const baseURL = process.env.REACT_APP_BACKEND_HOST;

export function fetchUserNotifications() {
  return [];
}

export function sendSystemNotification(notificationList, token) {
  return axios({
    method: 'POST',
    baseURL,
    url: '/notification/send',
    headers: {
      Authorization: token,
    },
    data: notificationList,
  }).then(response => response.data);
}



// WEBPACK FOOTER //
// ./src/services/systemNotifications/api.js